module.exports = require("core-js/modules/es.symbol.to-primitive.js");